import React from 'react';
// import {Col, Container, Row} from 'react-bootstrap';
import {Container} from 'react-bootstrap';
import ServiceContactInfoCardV2 from './ServiceContactInfoCardV2';
import {useIntl} from 'react-intl';

export interface ServiceContactInfo {
    service: string;
    days: string;
    hours: string;
    phoneNumber: string;
    choice?: string;
    email: string;
}

interface ServiceContactInfoGroupProps {
    className?: string;
}
const ServiceContactInfoGroupV2 = ({className}: ServiceContactInfoGroupProps): JSX.Element => {
    const intl = useIntl();
    const services: ServiceContactInfo[] = [
        {
            service: intl.formatMessage({id: 'TICKET.SERVICE.TECH'}),
            days: intl.formatMessage({id: 'TICKET.SERVICE.MON_VEN'}),
            hours: intl.formatMessage({id: 'TICKET.SERVICE.TECH.HOURS'}),
            phoneNumber: '01 70 17 60 30',
            choice: intl.formatMessage({id: 'TICKET.SERVICE.TECH.IVR'}),
            email: '',
        },
        {
            service: intl.formatMessage({id: 'TICKET.SERVICE.CLIENT'}),
            days: intl.formatMessage({id: 'TICKET.SERVICE.MON_VEN'}),
            hours: intl.formatMessage({id: 'TICKET.SERVICE.CLIENT.HOURS'}),
            phoneNumber: '01 70 17 60 30',
            choice: intl.formatMessage({id: 'TICKET.SERVICE.CLIENT.IVR'}),
            email: '',
        },
        {
            service: intl.formatMessage({id: 'TICKET.SERVICE.LIVRAISON'}),
            days: intl.formatMessage({id: 'TICKET.SERVICE.MON_VEN'}),
            hours: intl.formatMessage({id: 'TICKET.SERVICE.LIVRAISON.HOURS'}),
            phoneNumber: '01 70 17 60 30',
            choice: intl.formatMessage({id: 'TICKET.SERVICE.LIVRAISON.IVR'}),
            email: 'suivi-commandes@celeste.fr',
        },
        {
            service: intl.formatMessage({id: 'TICKET.SERVICE.COMMERCIAL'}),
            days: intl.formatMessage({id: 'TICKET.SERVICE.MON_VEN'}),
            hours: intl.formatMessage({id: 'TICKET.SERVICE.COMMERCIAL.HOURS'}),
            phoneNumber: '01 70 17 60 20',
            email: 'info@celeste.fr',
        },
    ];

    return (
        <Container fluid className={className}>
            <div className="d-flex flex-wrap">
                {services.map((service, index) => {
                    return (
                        <div
                            style={{width: '50%'}}
                            className="p-md-5 overflow-hidden"
                            key={index}
                        >
                            <ServiceContactInfoCardV2 serviceInfo={service} />
                        </div>
                    );
                })}
            </div>
        </Container>
    );
};

export default ServiceContactInfoGroupV2;
